import { Chip, Stack, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';
import { isMobile } from 'react-device-detect';
import type { ITag } from 'services/api/entities/tag';
import { SortType, TagStore } from 'services/store/tags';
import { DurationFilter, SortingFilter } from './components';
import useStyles from './style';

const MIN_SONG_DURATION = 1;
const MAX_SONG_DURATION = 600000;

type PropsType = {
  tagStore: TagStore;
  selectTag: (tag: ITag) => void;
  updateFilters: (appliedFilters: {
    minDuration: number;
    maxDuration: number;
    sortBy: Array<SortType>;
  }) => void;
};

const FiltersBar = (props: PropsType) => {
  const { tagStore, selectTag, updateFilters } = props;
  const { selectedTags, appliedFilters } = tagStore;
  const classes = useStyles();
  const { t } = useTranslation();

  const checkEmptySelectedTags = (): boolean => {
    const selectedTagsKeys = Object.keys(selectedTags);
    return (
      selectedTagsKeys.length === 0 ||
      selectedTagsKeys.every(
        (tagType: string) => selectedTags[tagType].length === 0
      )
    );
  };

  const updateDurationFilter = (duration: Array<number>): void => {
    let minDuration = duration[0];
    let maxDuration = duration[1];
    if (
      duration[0] < MIN_SONG_DURATION + 1000 &&
      duration[1] > MAX_SONG_DURATION - 1000
    ) {
      // @ts-ignore
      minDuration = null;
      // @ts-ignore
      maxDuration = null;
    }
    updateFilters({
      minDuration,
      maxDuration,
      // @ts-ignore
      sortBy: appliedFilters.sort_by,
    });
  };

  const updateSortingFilter = (sortingType: SortType): void => {
    updateFilters({
      // @ts-ignore
      minDuration: appliedFilters.min_Duration,
      // @ts-ignore
      maxDuration: appliedFilters.max_Duration,
      sortBy: [sortingType],
    });
  };

  return (
    <div className={classes.root}>
      <div className={classes.tagFilters}>
        {!checkEmptySelectedTags() ? (
          <Stack direction="row" spacing={2}>
            {Object.keys(selectedTags).map((tagType: string) =>
              selectedTags[tagType].map((tag: ITag) => (
                <Chip
                  data-testid="song-tag-chip"
                  key={tag.id}
                  label={tag.name}
                  variant="outlined"
                  deleteIcon={<CloseIcon />}
                  onDelete={() => selectTag(tag)}
                />
              ))
            )}
          </Stack>
        ) : (
          <Typography className={classes.selectedTagsPlaceholder}>
            {t('filtersBar:filtersPlaceholder')}
          </Typography>
        )}
      </div>
      {!isMobile && (
        <div className={classes.additionalFilters}>
          <DurationFilter
            minValue={MIN_SONG_DURATION}
            maxValue={MAX_SONG_DURATION}
            initialMinValue={appliedFilters.min_Duration ?? MIN_SONG_DURATION}
            initialMaxValue={appliedFilters.max_Duration ?? MAX_SONG_DURATION}
            onUpdate={(duration: Array<number>) => {
              updateDurationFilter(duration);
            }}
          />
          <SortingFilter
            initialValue={SortType.Popular}
            onUpdate={(sortingType: SortType) => {
              updateSortingFilter(sortingType);
            }}
          />
        </div>
      )}
    </div>
  );
};

export default FiltersBar;
